import { Button, Grid, TextField, Typography, Container, Box, Alert, InputAdornment, IconButton } from "@mui/material";
import { useContext, useState } from "react";
import Cookies from "js-cookie";
import { Link, useNavigate, useParams } from "react-router-dom";
import { AuthContest } from "../utils/AuthContext";
import axios from "axios";
import Header from "../../components/Header";
import { Helmet } from "react-helmet";

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

export default function LoginB() {
  const [validated, setValidated] = useState(false);
  const navigate = useNavigate();
  const [credidentials, setCredidentials] = useState({
    email: "",
    password: "",
  });
  const userParams = useParams();
  const userId = userParams.userId;
  const { loading, error, dispatch } = useContext(AuthContest);

  // État pour afficher/masquer le mot de passe
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setCredidentials((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  // Toggle visibilité du mot de passe
  const handleClickShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    dispatch({ type: "LOGIN_START" });
    try {
      const res = await axios({
        method: "post",
        url: "https://api.komorotel.com/api/auth/login",
        headers: { "Content-Type": "application/json" },
        data: {
          email: credidentials.email,
          password: credidentials.password,
        },
      });

      Cookies.set("access_token", res.data.access_token, {
        path: "/",
        secure: true,
        sameSite: "None",
        domain: ".komorotel.com",
      });

      dispatch({ type: "LOGIN_SUCCESS", payload: res.data });
      navigate("/");
    } catch (err) {
      dispatch({ type: "LOGIN_ERROR", payload: err.response.data.message });
      console.log(err);
    }
  };

  const sendVerificationMail = async () => {
    try {
      const res = await axios({
        method: "post",
        url: `https://api.komorotel.com/api/auth/sendVerificationMail/${userId}`,
        headers: { "Content-Type": "application/json" },
      });
    } catch (err) {
      dispatch({ type: "LOGIN_ERROR", payload: err.response.data });
      console.log(err);
    }
  };

  return (
    <>
      <Helmet>
        {/* Meta tags ici */}
      </Helmet>
      <Header disabled={true} />
      <Container>
        <Grid container spacing={3} justifyContent="center" alignItems="center" className="pt-7">
          <Grid item xs={12} sm={8} md={6}>
            <Box
              className="d-flex flex-column border shadow-sm p-4 rounded-3 m-3 h-100"
              sx={{ padding: 4 }}
            >
              <Typography variant="h5" fontWeight="bold">
                Se connecter ou créer un compte
              </Typography>
              <Typography variant="body1" color="textSecondary">
                Entrez vos informations afin de pouvoir profiter de nos services
              </Typography>
              <form noValidate validated={validated} onSubmit={handleSubmit} className="p-3">
                <TextField
                  fullWidth
                  label="Adresse e-mail"
                  type="email"
                  id="email"
                  value={credidentials.email}
                  onChange={handleChange}
                  required
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  fullWidth
                  label="Mot de passe"
                  type={showPassword ? "text" : "password"}  // <- modifié ici
                  id="password"
                  value={credidentials.password}
                  onChange={handleChange}
                  required
                  margin="normal"
                  variant="outlined"
                  InputProps={{  // <- ajouté pour l’icône œil
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowPassword}
                          edge="end"
                          color="primary"
                          aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
                <Typography variant="body2" fontWeight="bold" marginTop={2}>
                  Vous n'avez pas reçu le mail de vérification ?
                </Typography>
                <Link
                  onClick={sendVerificationMail}
                  style={{ textDecoration: "none", fontWeight: "bold" }}
                >
                  Appuyez ici pour le renvoyer
                </Link>
                <Box className="d-flex flex-column" marginTop={3}>
                  {error && (
                    <Alert severity="error" sx={{ mt: 2 }}>
                      {error.message || "Une erreur est survenue."}
                    </Alert>
                  )}
                  <Button
                    type="submit"
                    disabled={loading}
                    variant="contained"
                    color="primary"
                    sx={{ marginTop: 3 }}
                  >
                    Confirmer
                  </Button>
                </Box>
              </form>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
